<template>
  <div class="wallet">
    <div class="wallet-head">
      <div class="wallet-head-text">
        <h3 class="text-lg">₦250,670.80</h3>
        <p class="text-sm font-semibold">Wallet Balance</p>
      </div>
      <button type="" class="wallet-head-action p-2">
        <span class="flex gap-2 items-center">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 0C7.44772 0 7 0.447715 7 1V7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H7V15C7 15.5523 7.44772 16 8 16C8.55229 16 9 15.5523 9 15V9H15C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7H9V1C9 0.447715 8.55229 0 8 0Z" fill="#383F51"/>
          </svg>
          Top Up
        </span>
      </button>
    </div>
    <h3>Wallet Transaction Details</h3>
    <table class="wallet-table">
      <thead>
        <tr class="table-head">
          <td>Transaction</td>
          <td>Amount</td>
          <td>Status</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="flex gap-2 items-center">
              <span>
                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="30" cy="30" r="29.5" stroke="#B7BDCD"/>
                  <path d="M40 30V25H22.5C21.837 25 21.2011 24.7366 20.7322 24.2678C20.2634 23.7989 20 23.163 20 22.5C20 21.125 21.125 20 22.5 20H37.5V25" stroke="#7A90A7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M20 22.5V37.5C20 38.875 21.125 40 22.5 40H40V35" stroke="#7A90A7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M37.5 30C36.837 30 36.2011 30.2634 35.7322 30.7322C35.2634 31.2011 35 31.837 35 32.5C35 33.875 36.125 35 37.5 35H42.5V30H37.5Z" stroke="#7A90A7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span> 
              <div class="flex flex-col gap-2">
                <span>Credit</span>
                <span> Transaction ID 234556122345</span>
                <span>04 Apr, 2021  -  03:47 pm</span>
              </div>
            </div>
          </td>
          <td>₦50,000.00</td>
          <td>
            <div class="flex flex-col gap-2 items-center">
              <span>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9997 0.333252C8.89001 0.333252 6.82772 0.958841 5.0736 2.13091C3.31947 3.30298 1.9523 4.96888 1.14496 6.91796C0.337629 8.86704 0.126394 11.0118 0.53797 13.0809C0.949545 15.15 1.96545 17.0506 3.45721 18.5424C4.94897 20.0342 6.84959 21.0501 8.91872 21.4616C10.9878 21.8732 13.1326 21.662 15.0816 20.8546C17.0307 20.0473 18.6966 18.6801 19.8687 16.926C21.0408 15.1719 21.6663 13.1096 21.6663 10.9999C21.6663 8.17094 20.5425 5.45783 18.5422 3.45745C16.5418 1.45706 13.8287 0.333252 10.9997 0.333252ZM17.9663 7.41992L9.20635 16.1733L4.03301 10.9999C3.8562 10.8231 3.75687 10.5833 3.75687 10.3333C3.75687 10.0832 3.8562 9.8434 4.03301 9.66658C4.20982 9.48977 4.44963 9.39044 4.69968 9.39044C4.94973 9.39044 5.18953 9.48977 5.36635 9.66658L9.21968 13.5199L16.6463 6.09992C16.7339 6.01237 16.8378 5.94292 16.9522 5.89554C17.0666 5.84816 17.1892 5.82378 17.313 5.82378C17.4368 5.82378 17.5594 5.84816 17.6738 5.89554C17.7882 5.94292 17.8921 6.01237 17.9797 6.09992C18.0672 6.18747 18.1367 6.2914 18.1841 6.40579C18.2314 6.52017 18.2558 6.64277 18.2558 6.76658C18.2558 6.8904 18.2314 7.013 18.1841 7.12738C18.1367 7.24177 18.0672 7.3457 17.9797 7.43325L17.9663 7.41992Z" fill="#09B78A"/>
                </svg>
              </span>
              success
            </div>
          </td> 
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {
     wallet: false  
     
    };
  },
};
</script>
<style lang="scss" scoped>
.wallet-table{
  width: 100%;
}
.wallet-head{
  background: #FFF3DB;
  display:flex;
  justify-content: space-between;
  padding: 1rem;
  &-text{
    color: #FFA600;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  &-action{
    background: #FCC210;
  }
}
.table-head{
  background: #10233E;
  border-radius: 10px 10px 0px 0px;
  color:white;
}
</style>